import { registerDecorators as _registerDecorators, registerComponent as _registerComponent } from "lwc";
import _tmpl from "./zoomButtons.html";
import LightningElementSLDS from 'util/lightningElementSLDS';
import { fireEvent, eventTypes } from 'util/pubsub';
class ZoomButtons extends LightningElementSLDS {
  constructor(...args) {
    super(...args);
    // This is needed by the pubsub code to assure that events are only sent between components on the same page. We
    // need to come up with some attribute(s) that we can use to mark the components as belonging to a certain page/application.
    this.pageRef = {
      attributes: {
        "developer": "zPaper",
        "application": "Document Viewer"
      }
    };
    this.iconButtons = false;
  }
  zoomOut() {
    let self = this;
    console.log("zoom out clicked - start");
    fireEvent(self.pageRef, eventTypes.ZOOM_OUT, {});
    console.log("zoom out clicked - end");
  }
  zoomIn() {
    let self = this;
    console.log("zoom in clicked - start");
    fireEvent(self.pageRef, eventTypes.ZOOM_IN, {});
    console.log("zoom in clicked - end");
  }
}
_registerDecorators(ZoomButtons, {
  publicProps: {
    iconButtons: {
      config: 0
    }
  },
  fields: ["pageRef"]
});
export default _registerComponent(ZoomButtons, {
  tmpl: _tmpl
});